import hyperdom from 'hyperdom'
import times from 'lowscore/times'


class RoomGraphics {
  constructor (options) {
    this.room = options.room
    this.content = options.content
    this.roomTypesIcons = {
      'single': {singleBed: 1, doubleBed: 0, multiShare: 0},
      'twin': {singleBed: 2, doubleBed: 0, multiShare: 0},
      'twinShare': {singleBed: 2, doubleBed: 0, multiShare: 0},
      'triple': {singleBed: 1, doubleBed: 1, multiShare: 0},
      'tripleShare': {singleBed: 3, doubleBed: 0, multiShare: 0},
      'quad': {singleBed: 2, doubleBed: 1, multiShare: 0},
      'quadShare': {singleBed: 4, doubleBed: 0, multiShare: 0},
      'multiShare': {singleBed: 0, doubleBed: 0, multiShare: 1},
    }
  }

  render () {
    return <div class='room-graphics--redesigned'>
      <span class='room-graphics--redesigned__text'>{this.content}</span>
      {this.renderRoomIconsRedesigned()}
    </div>
  }


  renderShareRoom (shareSize, numberPassengers) {
    return times(shareSize, (i) => {
      return <i class={`room-graphics__icon icon-single-bed ${i + 1 > numberPassengers ? '-share' : ''}`}/>
    })
  }

  renderRoomIconsRedesigned () {
    let beds  = []
    const currentRoom = this.roomTypesIcons[this.room.roomType]

    if(this.room.share && this.room.roomType !== 'multiShare') {
      beds.push(...this.renderShareRoom(currentRoom.singleBed, this.room.occupants))
    } else {
      for (let i = 0; i < currentRoom.doubleBed; i++) {
        beds.push(<i class="room-graphics__icon icon-double-bed"/>)
      }
      for (let i = 0; i < currentRoom.singleBed; i++) {
        beds.push(<i class="room-graphics__icon icon-single-bed"/>)
      }
      for (let i = 0; i < currentRoom.multiShare; i++) {
        beds.push(<i class="room-graphics__icon icon-room"/>)
      }
    }

    return <div class="room-graphics--redesigned__icons">{beds}</div>
  }
}

export default RoomGraphics
